<div
  class="colors-container"
  *ngIf="layerStore.activeLayer | async as activeLayer"
  [class.common-colorscale]="isCommonColorScale"
>
  <!--
    Everything below is recomputed on every pass, deliberately. The colour
    scale is replaced whenever the map moves, the level changes or a new layer
    is picked, and `colorScaleForFeature` / `cellNumHistogram` are plain
    mutable fields on the service - so nothing here may be cached across
    passes. Hoisting into @let is only about doing the work once per pass
    instead of once (or twice) per colour bin.

    `isScaleStale` used to be `undefined | isAnimatedColorscale`: a *pure*
    pipe reading those mutable fields without taking them as arguments. With a
    constant argument it could never recompute, so it only ever refreshed by
    having its row destroyed and rebuilt - which is why this loop could not
    have a trackBy before.
  -->
  @let isScaleStale = colorScaleService.colorScaleForFeature !== activeLayer;
  @let isAnimated = isScaleStale || isBeingLoaded;
  @let isDataAbsent = colorScaleService.isDataAbsent;
  @let isCategorical = activeLayer | isCategoricalColorscale;
  @let histogramMax = histogramPeak;
  @let isSingleBin = colorScaleService.colorScaleColors.length === 1;

  <div
    *ngFor="
      let color of colorScaleService.colorScaleColors;
      first as isFirst;
      last as isLast;
      let i = index;
      trackBy: trackByIndex
    "
    class="color-text-container"
    [class.color-text-container-animated]="isAnimated"
    [class.menu-colorscale]="!isCommonColorScale"
  >
    @let binHeight =
      histogramMax > 0
        ? (colorScaleService.cellNumHistogram[i] / histogramMax) * 35
        : 0;
    @let rangeTooltip =
      isBeingLoaded
        ? 'Loading..'
        : colorScaleService.cellNumHistogram[i] +
          ' ' +
          activeLevel +
          '\n within ' +
          (colorScaleService.colorScaleColors
            | rangeTextFormatter: i : activeLayer);

    <div
      class="histogram-color"
      *ngIf="!isCommonColorScale && !isBeingLoaded && !isDataAbsent"
      [hidden]="isSingleBin"
      [style.background-color]="color[1]"
      [style.height.px]="binHeight"
      [style.margin-top.px]="-binHeight"
      [matTooltip]="rangeTooltip"
      [matTooltipPosition]="'above'"
    ></div>

    <button
      [class.first-button-as-color]="isFirst"
      [class.last-button-as-color]="isLast"
      [class.no-data-colorscale]="isDataAbsent && !isBeingLoaded"
      class="button-as-color"
      [style.background-color]="color[1]"
      [style.height]="isCommonColorScale ? '5px' : null"
      [matTooltip]="
        isBeingLoaded
          ? 'Loading..'
          : isDataAbsent
            ? 'No data available'
            : rangeTooltip
      "
      [matTooltipPosition]="'above'"
    >
      <div
        class="inner-circle"
        *ngIf="
          currentFeatureValue &&
          !isBeingLoaded &&
          currentFeatureValueCircleIndex === i &&
          !isDataAbsent &&
          !isSingleBin
        "
        [style.left.%]="currentFeatureValueCirclePosition"
        [matTooltip]="
          'Selected area value : ' +
          (currentFeatureValue | numberFormatter: 2 : activeLayer! : true)
        "
        [matTooltipPosition]="'above'"
      ></div>
    </button>

    <div
      class="number-value"
      *ngIf="
        !isBeingLoaded &&
        !isLast &&
        !isCategorical &&
        !isDataAbsent &&
        !isScaleStale
      "
    >
      {{ color[0] | numberFormatter: 2 : activeLayer }}
    </div>
    <div
      class="number-value center"
      *ngIf="
        !isBeingLoaded &&
        ((isFirst && isLast) || isCategorical) &&
        !isDataAbsent &&
        !isScaleStale
      "
    >
      {{ color[0] | numberFormatter: 2 : activeLayer }}
    </div>
  </div>
</div>
